import React, { useMemo } from 'react'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/styles'
import CheckIcon from '@material-ui/icons/Check'
import { styles } from './styles'

const useStyles = makeStyles(() => styles)

const columnsLabels = {
  uninterested: 'UNINTERESTED',
  interested: 'INTERESTED',
  booked: 'BOOKED',
  videoOnboarding: 'VIDEO ONBOARDING',
  test: 'TEST',
  refused: 'BLOCKED',
  onSiteTraining: 'ONSITE TRAINING',
  preAccess: 'PRE ACCESS',
  finalReview: 'WAITING FOR REVIEW',
  onsiteMeeting: 'ONSITE MEETING',
  approved: 'APPROVED',
}

export const ColumnsFilter = ({ columns, columnsState, setColumnsState }) => {
  const classes = useStyles()

  const handleColumnStateSwitch = key => {
    setColumnsState({ ...columnsState, [key]: !columnsState[key] })
  }

  const nonColumnsSelected = useMemo(
    () =>
      Object.entries(columnsState)
        .filter(([key, value]) => !!columns.find(c => c === key))
        .every(([key, value]) => !value),
    [columnsState, columns],
  )

  return (
    <div className={classes.columnsFilterContainer}>
      <div className={classes.columnsFilter} cypress_id={'ambs-columns-list'}>
        {columns.map(c => (
          <div
            key={c}
            className={classNames(classes.columnbutton, {
              [classes.columnOnButton]: columnsState[c],
              [classes.columnOffButton]: !columnsState[c],
            })}
            onClick={() => handleColumnStateSwitch(c)}
            cypress_id={`ambs-columns-item-${c}`}
          >
            <span>{columnsLabels[c]}</span>
            {columnsState[c] && (
              <div className={classes.checkIcon}>
                <CheckIcon fontSize={'small'} />
              </div>
            )}
          </div>
        ))}
      </div>
      {nonColumnsSelected && (
        <div className={classes.nonColumnsMessage}>
          Please unhide the columns to see the data
        </div>
      )}
    </div>
  )
}
